<template>
  <div>
    <DxPopup
      :visible="visible"
      :show-title="true"
      :title="$t('works.work_group_list.edit_group')"
      :width="800"
      :height="560"
      @hiding="onClose"
    >
      <form>
        <div class="row">
          <div class="form-row col-sm-12 col-lg-6">
            <label class="control-label"> {{ $t("common.name") }}</label>
            <DxTextBox v-model="name" :class="{ 'field-error': this.$v.name.$error }" />
          </div>
          <div class="form-row col-sm-12 col-lg-6">
            <label class="control-label">{{ $t("works.work_group_list.main_group") }}</label>
            <DxSelectBox :search-enabled="true" v-model="main_group_id" :data-source="mainGroupList" value-expr="id" display-expr="name" />
          </div>
        </div>
        <div class="row">
          <WorkGroupUnitPrice ref="unitPrices" :data="workGroupData.unit_prices" />
        </div>
        <div class="row">
          <div class="text-right">
            <SmagriaButton :label="$t('ok')" :action="saveWork" :customClass="'primary margin-top'" :width="'170px'" />
            <SmagriaButton :label="$t('common.cancel')" :action="onClose" :customClass="'secondary border margin-left margin-top'" :width="'130px'" />
          </div>
        </div>
      </form>
    </DxPopup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DxPopup from "devextreme-vue/popup";
import DxSelectBox from "devextreme-vue/select-box";
import DxTextBox from "devextreme-vue/text-box";
import { successMessage, errorMessage } from "@/helpers/common";
import required from "vuelidate/src/validators/required";
import WorkGroupUnitPrice from "./WorkGroupUnitPrice.vue";
import SmagriaButton from "@/components/Common/SmagriaButton.vue";

export default {
  name: "WorkGroupEdit",
  props: {
    workGroupData: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
    DxPopup,
    DxSelectBox,
    DxTextBox,
    WorkGroupUnitPrice,
    SmagriaButton,
  },
  data() {
    return {
      name: this.workGroupData.name,
      main_group_id: this.workGroupData.main_group_id ?? null,
      mainGroupList: [],
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      workTypes: "works-manager/works",
    }),
  },
  methods: {
    ...mapActions({
      changeWork: "works-manager/updateWork",
      getWork: "works-manager/getWork",
      getWorkMainGroups: "works-manager/getWorkMainGroups",
    }),
    onClose() {
      this.$emit("close");
    },
    saveWork() {
      this.$v.$touch(); // Trigger validation
      if (this.$v.$invalid) {
        errorMessage(this, this.$t("fill_out_error"));
        return;
      }

      this.update();
    },
    async update(key, obj) {
      let updatable = {};
      updatable = {
        uuid: this.workGroupData.uuid,
      };

      //ref unitPrices
      const unitPrices = this.$refs.unitPrices.getUnitPrices();
      updatable.unit_prices = unitPrices;
      updatable.name = this.name;
      updatable.display_name = this.name;
      updatable.main_group_id = this.main_group_id;

      // Call the update API
      await this.changeWork(updatable)
        .then((response) => {
          successMessage(this, "Work group has been updated.");
          this.$emit("save");
        })
        .catch((e) => {
          errorMessage(this, "Work group update error.");
        });
    },
  },
  mounted() {
    this.getWorkMainGroups({
      limit: 10000,
    }).then((response) => {
      response.unshift({ id: null, name: "" });
      this.mainGroupList = response;
    });
  },
  validations() {
    return {
      name: { required },
    };
  },
};
</script>

<style scoped>
.form-row {
  align-items: center;
  margin-bottom: 20px;
}

.control-label {
  padding-bottom: 5px;
}
</style>
